import {
    oracleMarketInformationsCacheSlice,
    selectMarketInformationsCacheState
} from "./oracleMarketInformationsCacheSlice";

export const AbfSdkCacheReducers = {
    oracleMarketInformationsCache: oracleMarketInformationsCacheSlice.reducer
} as const;

export { selectMarketInformationsCacheState };
